import { dmApi } from "../../../../app/dmApi";
import { serialize } from "../../../../helpers/Utils";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../../helpers/RtkQueryUtils";

export const gasConsumptionApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        searchGasConsumptions: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/gas-consumption?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['gas-consumption'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createGasConsumption: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/gas-consumption/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['gas-consumption'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created","Gas Consumption")
            },
        }),
        updateGasConsumption: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/gas-consumption/update`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['gas-consumption'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated","Gas Consumption")
            },
        }),
        removeGasConsumption: build.mutation({
            query: (id) => {
                return {
                    url: `/gas-consumption/${id}/delete`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Removed","Gas Consumption")
            },
            invalidatesTags: ['gas-consumption']
        }),
    }),
});


export const {
    useSearchGasConsumptionsQuery,
    useCreateGasConsumptionMutation,
    useUpdateGasConsumptionMutation,
    useRemoveGasConsumptionMutation,
} = gasConsumptionApi;